import React, { useContext, useEffect, useState } from 'react';
import { UserOrderContext } from 'context/context';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getAndCheck,
  isEmptyEvery,
  isCateringDisposition,
  getDispositionTypeOnAPIFormat,
  safeUpperCase,
  getValueOrDefaultObject,
  toastifyFnWithImage,
  checkAnyObjValTrue,
  getCheckIfAnyOnePass,
  getAndCheckIfOneTrue,
  getItemDetailsfrom,
  getUserType,
  getCouponDetails,
  calculatePrice,
  getDiscountedPrice,
} from 'common/utilities/utils';
import {
  checkCategoryAvailability,
  checkIteminCart,
  getCategoryUrl,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import SharedConstants, {
  LOCAL_STORAGE_KEYS,
  ROUTE_URL,
  priceRoundoff_value,
  priceFixed_value,
} from 'common/constants/SharedConstants';
import { useHistory } from 'react-router-dom';
import { RemoveItemAnalytic, RecommendedItemAnalytic } from 'common/utilities/analyticsUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';

const formattedPrice = (price, currencySymbol, currencyConversion) => {
  let roundOffPrice = (Math.round((price / currencyConversion) * priceRoundoff_value) / priceRoundoff_value).toFixed(
    priceFixed_value,
  );
  return `${currencySymbol}${roundOffPrice}`;
};

export const getClassNameForBtnDisabled = (pdpAddtoCartConfirmButtonDisabled, addToCartButtonText) => {
  return checkAnyObjValTrue(pdpAddtoCartConfirmButtonDisabled) ? 'pdp-button-disabled' : addToCartButtonText;
};

export const getAddToCartButtonText = (miniPDPDataForCart, dispositionType, isMobile) => {
  const { ADDTOCART, CUSTOMISE_FLAG_CART } = MENU_PDP_PAGE_CONSTANTS;
  const { SAVE_CHANGES, SAVE, ADD } = TRANSLATE_MAPPING_KEY;
  if (miniPDPDataForCart?.flag === CUSTOMISE_FLAG_CART) {
    return isCateringDisposition(dispositionType) ? translateWithI18Next(SAVE) : translateWithI18Next(SAVE_CHANGES);
  } else {
    return getAndCheck(isCateringDisposition(dispositionType), isMobile)
      ? translateWithI18Next(ADD)
      : translateWithI18Next(ADDTOCART);
  }
};

export const onKeyDownPress = e => {
  const { ENTER, PLUS, MINUS } = SharedConstants.KEY_CHAR_CODE;
  if (e.charCode === ENTER || e.charCode === PLUS || e.charCode === MINUS) {
    e.preventDefault();
  }
};
const getItemStatus = (IS_OUT_OF_STOCK, itemStatus) => {
  return itemStatus === IS_OUT_OF_STOCK ? true : false;
};
const getAlertType = itemInCart => {
  return itemInCart ? START_ORDER_CONSTANTS?.REVIEW_ORDER_MODAL : START_ORDER_CONSTANTS?.PDP_UNAVAILABLE_MODAL;
};
const QuantityModifierAddToCart = props => {
  const {
    prodQuantity,
    itemQuantity,
    userParams,
    quantityUpdate,
    dName,
    addtoCartClinckHandler,
    itemStatus,
    currencySymbol,
    currencyConversion,
    isMobile,
    handleProdQuantityForCatering,
    maxItemCountPerLineItem,
    modgrpMax,
    selectedItemNotAvailable,
    isItemDecreased,
    itemId,
  } = props;

  const cartReducer = useSelector(data => data.cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { currencyConversionFactor } = tenantReducer;
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { IS_OUT_OF_STOCK, OUT_OF_STOCK_TEXT, IS_IN_STOCK, CUSTOMISE_FLAG_CART } = MENU_PDP_PAGE_CONSTANTS;
  const { QUANTITY_TEXT, SELECT_TEXT, ADD_TO_YOUR_ORDER } = TRANSLATE_MAPPING_KEY;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const miniPDPDataForCart = userOrderState?.pdpDataForUpdateFoodLine;
  const {
    pdpPayloadData,
    pdpAddtoCartConfirmButtonDisabled,
    dispositionNew,
    pdpDataForUpdateFoodLine,
    timeBasedCetegory,
  } = userOrderState;
  const dispositionNewData = isEmptyEvery(dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : dispositionNew;
  const dispositionType =
    dispositionNewData?.type && safeUpperCase(getDispositionTypeOnAPIFormat(dispositionNewData?.type));
  const addToCartButtonText = getAddToCartButtonText(miniPDPDataForCart, dispositionType, isMobile);
  const isAddItemLoading = useSelector(data => data.cartReducer?.isAddItemLoading);
  const [isCateringCheck, setIsCateringCheck] = useState(false);
  const flatRes = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const history = useHistory();
  useEffect(() => {
    const cateringCheck = history?.location?.pathname?.includes(ROUTE_URL.CATERING_PAGE);
    setIsCateringCheck(cateringCheck);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const quantityUpdateTemplate = () => {
    return (
      <div
        className={`quantityAddtocart qty-calc mg-set ${
          prodQuantity ? 'cardwithQuantity ' + userParams.loggedIn : 'cardwithNoquantity'
        }`}
      >
        <LazyLoaderWrapper
          importPath='QUANTITY_MODIFIER_TEMPLATE'
          itemCount={prodQuantity}
          itemQuantity={itemQuantity}
          updateItemQuantity={quantityUpdate}
          quantityAction={QUANTITY_ACTION}
          item={undefined}
          itemName={dName}
          cartItemCount={1}
          maxItemCountPerLineItem={maxItemCountPerLineItem}
          hideChild={true}
          handleQuantityForCatering={handleProdQuantityForCatering}
          dispositionType={dispositionType}
          onKeyPressHandler={onKeyDownPress}
        />
      </div>
    );
  };

  const showToastMassage = event => {
    event.preventDefault();
    let imageTemplate = <img src={IMAGE_PATH.ErrorImage} alt='Error' />;
    let message = `${translateWithI18Next(SELECT_TEXT)} ${modgrpMax} ${translateWithI18Next(ADD_TO_YOUR_ORDER)}`;
    toastifyFnWithImage(message, imageTemplate, 'err-toast', true);
  };
  const addTocartHandler = (event, cartDataId) => {
    const { couponCode } = getCouponDetails(cartData);
    const { unitPrice, basePrice } = pdpPayloadData;
    const userType = getUserType(userParams?.localized, userParams?.loggedIn);
    const removeAnalyticitem = getItemDetailsfrom(flatRes, pdpPayloadData, cartData, currencyConversionFactor);
    const { quantity = 0 } = removeAnalyticitem?.[0] || { quantity: 0 };
    const couponObj = {
      couponCode,
    };
    const cartObj = { unitPrice, basePrice, cartData, quantity, currencyConversionFactor };
    const totalPrice = getDiscountedPrice(cartObj);
    const totalAmount = calculatePrice(unitPrice, currencyConversionFactor);
    const saveChangesItemdetails = [{ ...removeAnalyticitem[0], ...couponObj }];
    if (miniPDPDataForCart?.flag === CUSTOMISE_FLAG_CART) {
      RecommendedItemAnalytic(userType, saveChangesItemdetails, totalPrice);
    }
    if (isItemDecreased) {
      RemoveItemAnalytic(userType, removeAnalyticitem, +totalAmount.toFixed(2));
    }
    addtoCartClinckHandler(
      event,
      pdpPayloadData,
      miniPDPDataForCart,
      cartDataId,
      totalAmount,
      pdpDataForUpdateFoodLine,
      cartData,
    );
  };
  const checkItemExpiry = (event, cartData1) => {
    event?.stopPropagation();
    event?.preventDefault();
    const categoryUrl = getCategoryUrl(itemId, flatRes);
    const itemInCart = checkIteminCart(itemId, timeBasedCetegory);
    const categoryExpried = checkCategoryAvailability(
      { categoryUrl: categoryUrl, itemInCart: itemInCart, alertType: getAlertType(itemInCart) },
      timeBasedCetegory,
      userOrderStateDispatch,
    );
    if (categoryExpried) {
      return;
    }
    checkAnyObjValTrue(pdpAddtoCartConfirmButtonDisabled)
      ? showToastMassage(event)
      : addTocartHandler(event, cartData1?.id);
  };
  const addToCartTemplate = () => {
    return (
      <ContainedButton
        tabIndex='1'
        variant={ButtonType.primary}
        fullWidth
        hasPrices
        inactive={getAndCheckIfOneTrue(
          getItemStatus(IS_OUT_OF_STOCK, itemStatus),
          getCheckIfAnyOnePass(isAddItemLoading, selectedItemNotAvailable, !prodQuantity),
        )}
        loading={isAddItemLoading}
        data-testid='add-to-cart-handler'
        onClick={event => checkItemExpiry(event, cartData)}
        disabled={getCheckIfAnyOnePass(
          getItemStatus(IS_OUT_OF_STOCK, itemStatus),
          selectedItemNotAvailable,
          !prodQuantity,
        )}
        className={checkAnyObjValTrue(pdpAddtoCartConfirmButtonDisabled) ? 'button-contained-disabled' : ''}
      >
        {getAndCheck(
          getAndCheckIfOneTrue(getItemStatus(IS_OUT_OF_STOCK, itemStatus), selectedItemNotAvailable),
          !getItemStatus(IS_IN_STOCK, itemStatus),
        ) ? (
          <span className='outofstock'>{translateWithI18Next(OUT_OF_STOCK_TEXT)}</span>
        ) : (
          <>
            <span>{addToCartButtonText}</span>
            {currencyConversion && (
              <span>{formattedPrice(pdpPayloadData?.unitPrice, currencySymbol, currencyConversion)}</span>
            )}
          </>
        )}
      </ContainedButton>
    );
  };

  const getQtyModifierAddToCartMobileView = () => {
    return (
      <div className={`pdp-mobile-quantity-price-sopac fixedDiv ${getAndCheck(isCateringCheck, 'catering-button')}`}>
        <div className='pdp-quantity-block pdp-quantity-block-sopac'>{quantityUpdateTemplate()}</div>
        {addToCartTemplate()}
      </div>
    );
  };

  const getQtyModifierAddToCartDesktopView = () => {
    return (
      <div>
        <div className='pdp-quantity-block pdp-quantity-block-sopac'>
          <label className='qty'>{translateWithI18Next(QUANTITY_TEXT)}</label>
          {quantityUpdateTemplate()}
        </div>
        {addToCartTemplate()}
      </div>
    );
  };

  const mobileView = getAndCheck(isMobile, getQtyModifierAddToCartMobileView());
  const desktopView = getAndCheck(!isMobile, getQtyModifierAddToCartDesktopView());

  return (
    <>
      {desktopView}
      {mobileView}
    </>
  );
};

export default QuantityModifierAddToCart;
